module.exports = __webpack_public_path__ + "media/images/application/logo-poulpe-footer-331f7df19c0feaa91cf1ae585747f684.svg";